import { render, staticRenderFns } from "./SAPK_rwkursus_Modal.vue?vue&type=template&id=a8a73dca"
import script from "./SAPK_rwkursus_Modal.vue?vue&type=script&lang=js"
export * from "./SAPK_rwkursus_Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports